/* eslint-disable react/display-name */
import { useState, type InputHTMLAttributes, forwardRef } from "react";
import { Path, UseFormRegister } from "react-hook-form";
import { CheckboxOptions } from "services/sell-my-car/sellMyCarAppraisalService";
import classNames from "classnames/bind";
import styles from "./Checkbox.module.scss";

const cx = classNames.bind(styles);

export type CheckboxProps = CheckboxOptions &
    InputHTMLAttributes<HTMLInputElement> & {
        register?: UseFormRegister<any>;
    };

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({ ...props }, ref) => {
    const [isSelected, setIsSelected] = useState(props.isChecked);
    const { label, register, ...attrs } = props;
    const Label = !label ? "div" : "label";

    const handleOnClick = (e: any) => {
        if (isSelected) {
            setIsSelected(false);
        } else {
            setIsSelected(true);
        }
    };

    return (
        <Label className={cx("container", props.className)} data-checked={isSelected} tabIndex={0}>
            <input
                {...attrs}
                {...(register ? register(`${props.value ?? props.label}` as Path<any>) : {})}
                className={cx("input")}
                type="checkbox"
                defaultChecked={props.isChecked}
                ref={ref}
                onClick={handleOnClick}
                tabIndex={-1}
            />
            {label && <span className={cx("label")}>{label}</span>}
        </Label>
    );
});

export default Checkbox;
